import {IEntryFieldForManipulation} from '../../../_interface/ientry-field-for-manipulation';
import {DrawSymbolPlaced, DrawSymbolPlacing} from '../_interface/current-symbol-drag.interface';
import {Dictionary} from '@ngrx/entity';
import {DrawSymbol} from '../_interface/symbol.model';
import {FabricPlacedSymbol} from '../_interface/placed-fabric-symbol.interface';
import {DrawObjectType} from '../_interface/fabric-area.interface';
import {IHistoricValue} from '../../../_interface/ientry-field-for-show';
import {INACTIVE_SYMBOL_COLOR, PRIMARY_SYMBOL_COLOR} from 'shared/magic';

export const convertPlacedToPlacingSymbol = (placed: DrawSymbolPlaced): DrawSymbolPlacing => ({
	symbol: placed.symbol,
	placedSymbolId: placed.placedSymbol.placedSymbolId,
	schemaId: placed.placedSymbol.schemaId,
	coords: {top: placed.placedSymbol.top, left: placed.placedSymbol.left},
	angle: placed.placedSymbol.angle,
	scale: placed.placedSymbol.scaleX,
	active: placed.active,
	flip: placed.placedSymbol.flipX
});

export const convertFieldToPlacingSymbol = (field: IEntryFieldForManipulation, symbols: Dictionary<DrawSymbol>): DrawSymbolPlacing => {
	const {active, symbolId, schemaId, placedSymbolId, top, left, angle, scale, flip} = field.content;
	const color = active ? PRIMARY_SYMBOL_COLOR : INACTIVE_SYMBOL_COLOR;
	return {
		symbol: symbols[symbolId],
		placedSymbolId,
		schemaId,
		coords: {left, top},
		angle,
		scale,
		active,
		color,
		flip
	};
};

export const convertFieldToPlacedSymbol = (
	entryId: string,
	field: IEntryFieldForManipulation,
	symbols: Dictionary<DrawSymbol>
): DrawSymbolPlaced => {
	const {
		symbolId, schemaId, placedSymbolId, top, left,
		angle, flip, scale, description, active, modificationDate
	} = field.content as IHistoricValue;
	if (!Object.keys(symbols).find(key => key === symbolId)) return null;
	const placedSymbol = {
		...symbols[symbolId].normalizedObject as FabricPlacedSymbol,
		placedSymbolId,
		top, left,
		angle,
		symbolId,
		flipX: flip,
		scaleX: scale,
		drawType: DrawObjectType.placedSymbol,
		schemaId
	} as FabricPlacedSymbol;
	return {
		symbol: symbols[symbolId],
		placedSymbol,
		description,
		active,
		entryId,
		modificationDate,
		fieldId: field.fieldId
	};
};
